<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TAB_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="frame1.searchFrame.tableSearchText"
              @keyup.enter="onClickSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset "
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB10" />
      <sui-grid
        ref="grid"
        :columns="gridColumns2"
        :dataset="'dsTableColumn'"
        :multiselect="true"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickClose"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickSelect"
      >
        {{ $t('MSG_TXT_SEL') }}
      </sui-button>
    </div>
  </div>
</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMU_00016_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    objectId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      frame1: {
        searchFrame: {
          tableSearchText: '',
        },
        objectColumnUid: '',
        objectId: this.objectId,
        tablePhysicalName: '',
        columnName: '',
        columnTypeCode: '',
        columnSizeValue: '',
        inputSizeValue: '0',
        primaryKeyYn: 'N',
        notNullYn: 'N',
        searchItemYn: 'N',
        codeId: '',
        objectColumnMultilanguageId: '',
        messageResourceValue: '',
      },
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsTableColumn',
    type: 'local',
    data: 'localdata2',
    datafields: [
      { type: 'string', name: 'objectColumnUid', map: 'objectColumnUid' },
      { type: 'string', name: 'tablePhysicalName', map: 'tablePhysicalName' },
      { type: 'string', name: 'columnName', map: 'columnName' },
      { type: 'string', name: 'columnTypeCode', map: 'columnTypeCode' },
      { type: 'string', name: 'columnSizeValue', map: 'columnSizeValue' },
      { type: 'string', name: 'inputSizeValue', map: 'inputSizeValue' },
      { type: 'string', name: 'primaryKeyYn', map: 'primaryKeyYn' },
      { type: 'string', name: 'notNullYn', map: 'notNullYn' },
      { type: 'string', name: 'searchItemYn', map: 'searchItemYn' },
      { type: 'string', name: 'codeId', map: 'codeId' },
      { type: 'string', name: 'objectColumnMultilanguageId', map: 'objectColumnMultilanguageId' },
      { type: 'string', name: 'messageResourceValue', map: 'messageResourceValue' },
      { type: 'string', name: 'defaultMessageResourceValue', map: 'defaultMessageResourceValue' },
    ],
  }],
  created() {
    this.gridColumns2 = [{
      text: this.$t('MSG_TXT_TAB_NM'),
      datafield: 'tablePhysicalName',
    }, {
      text: this.$t('MSG_TXT_COL_NM'),
      datafield: 'columnName',
    }, {
      text: this.$t('MSG_TXT_MSG_RESO_VAL'),
      datafield: 'messageResourceValue',
    }, {
      text: this.$t('MSG_TXT_MSG_RESO_DEF_VAL'),
      datafield: 'defaultMessageResourceValue',
    }];
    this.localData2 = [];
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onClickReset() {
      this.frame1.searchFrame.tableSearchText = '';
    },
    onClickSearch() {
      if (utils.isEmpty(utils.trim(this.frame1.searchFrame.tableSearchText))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_TAB_NM')));
        return false;
      }

      http.request(this.contextPageId, 'DTS_CMU_00076', {
        path: {
          'table-name': this.frame1.searchFrame.tableSearchText,
        },
      }).then(res => {
        if (utils.isEmpty(res.data)) {
          utils.messageBox('warning', this.$t('MSG_ALT_NO_INFO_SRCH'));
        }
        this.dsTableColumn.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
      return true;
    },
    onClickSelect() {
      const selectedData = this.dsTableColumn.getSelectedRawData();
      if (selectedData.length !== 0) {
        this.$emit('paramReturn', selectedData, 'tableColumnList');
        this.$emit('closePopup');
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onClickClose() {
      this.$emit('closePopup');
    },
  },
};
</script>
<style scoped>
</style>
